import { useTranslation } from 'react-i18next';

export function LanguageSwitcher({ compact }: { compact?: boolean }) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith('en') ? 'en' : 'de';

  const toggle = () => {
    i18n.changeLanguage(currentLang === 'de' ? 'en' : 'de');
  };

  if (compact) {
    return (
      <button
        onClick={toggle}
        className="text-[10px] text-gray-400 hover:text-gray-600 transition-colors px-1.5 py-0.5 rounded hover:bg-gray-100"
        title={currentLang === 'de' ? 'Switch to English' : 'Zu Deutsch wechseln'}
      >
        {currentLang === 'de' ? 'EN' : 'DE'}
      </button>
    );
  }

  return (
    <button
      onClick={toggle}
      className="flex items-center gap-1.5 text-[10px] text-gray-400 hover:text-gray-600 transition-colors px-2 py-1 rounded hover:bg-gray-100"
      title={currentLang === 'de' ? 'Switch to English' : 'Zu Deutsch wechseln'}
    >
      <span className={currentLang === 'de' ? 'font-medium text-gray-700' : ''}>DE</span>
      <span className="text-gray-300">/</span>
      <span className={currentLang === 'en' ? 'font-medium text-gray-700' : ''}>EN</span>
    </button>
  );
}
